


































































































import Vue from 'vue'
import store from '@/store/store';
import { mapGetters } from 'vuex';
import CreateTimelineModal from './timelinelist/CreateTimelineModal.vue';
import CreateFolderModal from './timelinelist/CreateFolderModal.vue';
import EditMapModal from './timelinelist/EditMapModal.vue';
import Project from '../models/Project';
import ProjectEditor from './dashboard/projects/ProjectEditModal.vue';
import BestFitText from "@/components/BestFitText.vue";
import SupportForm from '@/components/support/SupportForm.vue';
import { BvModalEvent } from 'bootstrap-vue';
import FolderCommands from '../networking/Folder';

export default Vue.extend({
	components: {
		CreateTimelineModal,
		CreateFolderModal,
		EditMapModal,
		ProjectEditor,
		BestFitText,
		SupportForm
	},
	data()
	{
		return {
			modalLoad: false,
			modalKey: 0
		};
	},
	methods:
	{
		supportModalSubmit(modal : BvModalEvent)
		{
			modal.preventDefault();
			this.$nextTick(()=>{
				(this.$refs['supportForm'] as SupportForm).submit();
			})
		},
		showModal(name : string)
		{
			this.modalLoad = true;
			setTimeout(()=>
			{
				(this.$refs[name] as any).show();
			}, 0);
		},
		navigate(path : string)
		{
			if (this.$route.path != path)
			{
				this.$router.push(path);
			}
		},
		clickCreateFolder()
		{
			(this.$refs as any).createFolderModal.show();
		},
		clickCreateTimeline() : void
		{
			this.$root.$emit('bv::hide::tooltip', 'create-timeline-tooltip');
			(this.$refs as any).createTimelineModal.show();
		},
		/*
		getNavItems()
		{
			return [
				{
					text: "Timelines",
					click: () => {}
				}
			];
		}*/
	},
	computed: {
		...mapGetters([
			'checkMapEdit',
			'checkMetadataEdit',
			'checkFolderEdit'
        ]),
		project() {
			return (store.state as any).project.project;
		},
		projectName(){
			return (store.state as any).project.project.name;
		},
		projectDescription(){
			return (store.state as any).project.project.description;
		}
	},
	mounted()
	{
		let timer = setInterval(()=>{
			if (this.$refs.timelineList)
			{
				this.$forceUpdate();
				clearInterval(timer);
			}
		}, 16);
	},
})
